import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBus } from "@fortawesome/free-solid-svg-icons";
import PlanItemBase from "./PlanItemBase";
import ItemDescription from "./ItemDescription";

const TransportItem = ({ item }) => {
  const time = new Date(item.startDate).toLocaleTimeString("pl-PL", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <PlanItemBase
      icon={<FontAwesomeIcon icon={faBus} className="plan-icon" />}
      time={time}
      name={item.name}
    >
      <div className="item-details">
        {item.link && (
          <p>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              Link
            </a>
          </p>
        )}
                {item.description && (
                  <ItemDescription description={item.description} />
        )}
      </div>
    </PlanItemBase>
  );
};

export default TransportItem;
